var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87495 19.1L11.3 10.7C11.4 10.6 11.4706 10.4917 11.512 10.375C11.554 10.2583 11.575 10.1333 11.575 9.99999C11.575 9.86666 11.554 9.74166 11.512 9.62499C11.4706 9.50833 11.4 9.39999 11.3 9.29999L2.87495 0.874994C2.64162 0.64166 2.34995 0.524994 1.99995 0.524994C1.64995 0.524994 1.34995 0.649994 1.09995 0.899994C0.849953 1.14999 0.724953 1.44166 0.724953 1.77499C0.724953 2.10833 0.849953 2.39999 1.09995 2.64999L8.44995 9.99999L1.09995 17.35C0.866619 17.5833 0.749952 17.8707 0.749952 18.212C0.749952 18.554 0.874952 18.85 1.12495 19.1C1.37495 19.35 1.66662 19.475 1.99995 19.475C2.33329 19.475 2.62495 19.35 2.87495 19.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/NextButton.788a817029e13723a96171943fa1fbab.svg";
export { ForwardRef as ReactComponent };